<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>post_add</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>Modificar Estado del Reclamo</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field
                v-model="reclamo.numeroReclamo"
                label="Reclamo N°: "
                key="numeroReclamo"
                :disabled="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field
                v-model="reclamo.solicitante"
                label="De: "
                key="solicitante"
                :disabled="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field
                v-model="reclamo.cuil"
                label="Cuil N°: "
                key="cuil"
                :disabled="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field
                v-model="reclamo.estado"
                label="Estado Actual del Reclamo: "
                key="estado"
                :disabled="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                label="Pasar a: "
                v-model="model.estadoReclamoId"
                :items="estadosReclamo"
                autocomplete="disabled"
                item-text="descripcion"
                item-value="id"
                placeholder="Seleccione una"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="model.comentarios"
                class="mx-2"
                label="Comentarios Adicionales"
                prepend-icon="comment"
                clearable
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cancelar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="modificaReclamo"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { addDays, format } from 'date-fns';
import { Decimal } from 'decimal.js';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data: () => ({
    saving: false,
    model: {
      estadoReclamoId: 0,
      comentarios: '',
    },
    estadosReclamo: [],
    menu1: '',
    menu2: '',
    menu3: '',
  }),
  props: {
    modo: { type: String },
    reclamo: {
      type: Object,
    },
  },

  created() {
    this.loadEstados();
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user']),
    listCreditosActivos: function() {
      if (!this.listDeudas || this.listDeudas.length == 0) return [];
      let lista = this.listDeudas.filter(
        (i) => i.tipo == 'Credito' || i.tipo == 'Acuerdo'
      );

      return lista;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    async modificaReclamo() {
      if (!this.validarAlta()) return;

      var params = {};
      params.Id = this.reclamo.id;
      params.accionActualId = this.model.estadoReclamoId;
      params.comentarios = this.model.comentarios;
      console.log(params);
      try {
        this.saving = true;
        var result = await http.put(
          'reclamos/modificareclamo',
          JSON.stringify({ parametros: params })
        );

        this.alertSuccess(
          'Se ha modificado el Estado del Reclamo Nº ' + result.entity.numero
        ); // + res.numero
        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.saving = false;
    },
    validarAlta() {
      if (!this.model.estadoReclamoId) {
        this.alertWarning('Debe elegir un Estado del Reclamo.');
        return false;
      }
      if (this.model.estadoReclamoId == this.reclamo.estadoId) {
        this.alertWarning('Debe elegir un Estado distinto al del Reclamo.');
        return false;
      }
      if (!this.model.comentarios) {
        this.alertWarning('Debe agregar un comentario al Reclamo.');
        return false;
      }

      return true;
    },
    async loadEstados() {
      this.loading = true;
      try {
        var result = await http.get('reclamos/list/tipoaccionesreclamo');

        this.estadosReclamo = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
